<div class="form-panel-container">
    @if (!loading) {
        <app-item-access
            [disabled]="disabled"
            [reachableElement]="group"
            [icon]="faViews"
            availableItemsTitle="Vues disponibles"
            [inheritedAccess]="inheritedViewsAccess"
            [allItems]="allViewsAccess"
            [availableItems]="availableViewsAccess"
            [selectedItems]="selectedViewsAccess"
            (accessUpdated)="onAccessUpdated($event)"></app-item-access>
    }

    <div class="buttons-container">
        @if (!disabled) {
            <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
        }
        <button mat-raised-button class="accent-button" (click)="$event.stopPropagation(); onExported()">Exporter</button>
        @if (!disabled) {
            <button mat-raised-button class="accent-button" (click)="$event.stopPropagation(); fileToUpload.click()">Importer</button>
            <button mat-raised-button class="accent-button" (click)="save()">Enregistrer</button>
        }
        <input ng2FileSelect #fileToUpload class="file-to-upload" type="file" [uploader]="uploader" (change)="onFileSelected()" [hidden]="true" />
    </div>
</div>
